
<template>
  <div class="flex items-center space-x-2">
    <div 
      class="w-2 h-2 rounded-full transition-colors duration-300"
      :class="statusClasses"
    ></div>
    <span class="text-sm font-medium" :class="textClasses">
      {{ statusText }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (value) => ['connected', 'disconnected', 'reconnecting', 'error'].includes(value)
  }
})

const statusClasses = computed(() => {
  switch (props.status) {
    case 'connected':
      return 'bg-green-500 animate-pulse'
    case 'reconnecting':
      return 'bg-yellow-500 animate-pulse'
    case 'error':
      return 'bg-red-500'
    case 'disconnected':
    default:
      return 'bg-gray-400'
  }
})

const textClasses = computed(() => {
  switch (props.status) {
    case 'connected':
      return 'text-green-700'
    case 'reconnecting':
      return 'text-yellow-700'
    case 'error':
      return 'text-red-700'
    case 'disconnected':
    default:
      return 'text-gray-500'
  }
})

const statusText = computed(() => {
  switch (props.status) {
    case 'connected':
      return 'Connected'
    case 'reconnecting':
      return 'Reconnecting...'
    case 'error':
      return 'Connection Error'
    case 'disconnected':
    default:
      return 'Disconnected'
  }
})
</script>